import { TournFlags } from '@ps/web-poker-types';

import type { Tournament } from '../../types/MTT';

const getIsSng = (tournFlags: Tournament['tournFlags']): boolean =>
  // eslint-disable-next-line no-bitwise
  Boolean(tournFlags & TournFlags.TOURNSCRIPT_FLAG_SITANDGO);

export default getIsSng;
